import React from "react";
import Style from "@assets/css/repair.module.css";
import { handleClassNames } from "lib/cssHelpers";
import {
  setCartJourney,
  setSelectedQuotationForm,
  setShowMobileIstand,
} from "../../../redux/actions/cartAction";
import { connect } from "react-redux";
import { setCarPopup } from "../../../redux/actions/globalAction";
import { useState } from "react";
import { useEffect } from "react";
import { normalQuotation } from "lib/config";
import { isMobile } from "react-device-detect";
import { setLayer } from "../../../redux/actions/globalAction";
import Skeleton from "react-loading-skeleton";
import RepairInsuranceItem from "./services/RepairInsuranceItem";
import ChooseCarMobile from "components/common/ChooseCarMobile";
const NewRepair = ({
  variants,
  setCartJourney,
  setSelectedQuotationForm,
  cart,
  setShowMobileIstand,
  globalData,
  setCarPopup,
  setLayer,
  id,
  handleShow,
  getCarBrandModal,
  getModel,
  getWorkshopFilterMap,
  showDescription,
  setShowDescription,
  setTypeOne,
  setTypeTwo,
  setServiceData,
  serviceData,
  variantId,
}) => {
  const [list1, setList1] = useState(null);
  const [list2, setList2] = useState(null);
  const [notSure, setNotSure] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showMobileChooseCar, setShowMobileChooseCar] = useState(false);

  const images = [
    {
      Name: "Steering Repair",
      img: "/assets/repair/Steering.svg",
      activeimg: "/assets/repair/Steering-active.svg",
    },
    {
      Name: "Underbody/ Suspension",
      img: "/assets/repair/Underbody.svg",
      activeimg: "/assets/repair/Underbody-active.svg",
    },
    {
      Name: "Gear/ Transmission",
      img: "/assets/repair/gear.svg",
      activeimg: "/assets/repair/gear-active.svg",
    },
    {
      Name: "Axle/ Shocks & Mounts",
      img: "/assets/repair/axle.svg",
      activeimg: "/assets/repair/axle-active.svg",
    },
    {
      Name: "AC",
      img: "/assets/repair/ac.svg",
      activeimg: "/assets/repair/ac-active.svg",
    },
    {
      Name: "Denting/ Painting",
      img: "/assets/repair/paint.svg",
      activeimg: "/assets/repair/paint-active.svg",
    },
    {
      Name: "Brakes",
      img: "/assets/repair/brakes.svg",
      activeimg: "/assets/repair/brakes-active.svg",
    },
    {
      Name: "Electrical/ Warning Lights",
      img: "/assets/repair/warning.svg",
      activeimg: "/assets/repair/warning-active.svg",
    },
    {
      Name: "Engine",
      img: "/assets/repair/engine.svg",
      activeimg: "/assets/repair/engine-active.svg",
    },
  ];
  useEffect(() => {
    setLoading(true);
  }, []);

  useEffect(() => {
    if (variants && variants.length) {
      if (
        variants &&
        variants.some((item) => item?.IslandType !== "QUOTATION")
      ) {
      } else {
        setLoading(false);
      }
      var half_length = Math?.ceil(variants?.length / 2);
      var leftSide = variants?.slice(0, half_length);
      var rightSide = variants?.slice(half_length);
      setList1(rightSide);
      setList2(leftSide);
      rightSide?.map((item) =>
        item.Name == "Not Sure - Help Me Out" ? setNotSure(item) : null
      );
      setLoading(false);
    }
  }, [variants]);

  const handleItemClicks = (item) => {
    if (!globalData?.carData) {
      setCarPopup("brand");
    } else if (item.IslandType === normalQuotation) {
      setLayer(true);
      if (isMobile) {
        setShowMobileIstand(true);
      }
      localStorage.setItem("product-id", JSON.stringify(item?.Id));
      setCartJourney(normalQuotation);
      setSelectedQuotationForm(item);
    }
  };
  const handleClasses = (classValue) => {
    return handleClassNames(classValue, Style);
  };
  const handleImages = (item, active = false) => {
    const data = images.filter((img) => img.Name == item.Name);
    return active ? data[0]?.activeimg : data[0]?.img;
  };

  return (
    <main className={`${handleClasses("main--sr-block-block")} px-0`}>
      <ChooseCarMobile
        show={showMobileChooseCar}
        setShow={setShowMobileChooseCar}
      />
      <section>
        {list1 && list1.length
          ? list1
              ?.filter((item) => item.IslandType == "OBWORKSHOP")
              .map((item) => {
                return (
                  <RepairInsuranceItem
                    id={id}
                    variant={item}
                    getModel={getModel}
                    getCarBrandModal={getCarBrandModal}
                    getWorkshopFilterMap={getWorkshopFilterMap}
                    showDescription={showDescription}
                    setShowDescription={setShowDescription}
                    showMobileChooseCar={showMobileChooseCar}
                    setShowMobileChooseCar={setShowMobileChooseCar}
                    setTypeTwo={setTypeTwo}
                    setTypeOne={setTypeOne}
                    setServiceData={setServiceData}
                    serviceData={serviceData}
                    variantId={variantId}
                  />
                );
              })
          : null}
        <p className="text-dark h4 font-weight-bold text-center my-4">
          What Repair Are You Looking For?
        </p>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              {/* <div className={handleClasses("image-block")}>
                <img
                  className="img-fluid"
                  src="/assets/repair/repair.svg"
                  alt="repair"
                />
              </div> */}
              <div className={handleClasses("repair-listblock")}>
                <div className={handleClasses("rep-container")}>
                  <ul className={handleClasses("repul")}>
                    {list1 && !loading
                      ? list1
                          .filter((item) => item?.IslandType === "QUOTATION")
                          ?.map((item) => {
                            return (
                              item?.Name != "Not Sure - Help Me Out" && (
                                <li
                                  className={handleClasses(
                                    cart?.selectedQuotationForm?.Id == item?.Id
                                      ? "active"
                                      : ""
                                  )}
                                  onClick={() => handleItemClicks(item)}
                                >
                                  <div
                                    className={`${handleClasses("rep-blc")}`}
                                  >
                                    <span>
                                      <img
                                        src={handleImages(
                                          item,
                                          cart.selectedQuotationForm?.Id ==
                                            item?.Id
                                        )}
                                        alt="ob-image"
                                      />
                                    </span>
                                    <label>{item.Name}</label>
                                  </div>
                                </li>
                              )
                            );
                          })
                      : [null, null, null, null].map((item, index) => {
                          return (
                            <li
                              style={{ background: "white", zIndex: 0 }}
                              key={index}
                            >
                              <Skeleton height={100} />
                            </li>
                          );
                        })}
                  </ul>
                </div>
                <div className={handleClasses("rep-container sc-rep-block")}>
                  <ul className={handleClasses("repul")}>
                    {list2 && !loading
                      ? list2?.map((item) => (
                          <li
                            className={handleClasses(
                              cart.selectedQuotationForm?.Id === item?.Id
                                ? "active"
                                : ""
                            )}
                            onClick={() => handleItemClicks(item)}
                            key={item?.Id}
                          >
                            <div className={handleClasses("rep-blc")}>
                              <span>
                                <img
                                  src={handleImages(
                                    item,
                                    cart.selectedQuotationForm?.Id === item?.Id
                                  )}
                                  alt={item.Name}
                                />
                              </span>
                              <label>{item.Name}</label>
                            </div>
                          </li>
                        ))
                      : [null, null, null, null, null].map((item) => {
                          return (
                            <li style={{ background: "white", zIndex: 0 }}>
                              <Skeleton height={100} />
                            </li>
                          );
                        })}
                  </ul>
                </div>
                <div
                  className={handleClasses("hel-me-out")}
                  onClick={() => handleItemClicks(notSure)}
                >
                  <a
                    href="javascript:void(0)"
                    className={handleClasses("hel-me-btn")}
                  >
                    <span>
                      <img src="/assets/repair/help.svg" alt="help" />
                    </span>
                    <label>
                      <strong>Not Sure</strong>
                      <i>Help Me Out</i>
                    </label>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};
const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    globalData: state.globalData,
    apiData: state.apiData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCartJourney: (stage) => {
      dispatch(setCartJourney(stage));
    },
    setSelectedQuotationForm: (item) => {
      dispatch(setSelectedQuotationForm(item));
    },
    setShowMobileIstand: (flag) => {
      dispatch(setShowMobileIstand(flag));
    },
    setCarPopup: (flag) => {
      dispatch(setCarPopup(flag));
    },
    setLayer: (status) => {
      dispatch(setLayer(status));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewRepair);
